import { SidenavService } from './../../services/sidenav.service';
import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
@Component({
  standalone: false,
  selector: 'app-organisation-detail',
  templateUrl: './organisation-detail.component.html',
  styleUrls: ['./organisation-detail.component.scss']
})
export class OrganisationDetailComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string; }[];
  @Input() tenant: any = {};
  @Output() refreshCredit = new EventEmitter<any>();
  url: string;
  tenantUser: any[];
  tenantUsers: any[];
  searchTerm: string;
  token: any;
  page = 1;
  pageSize = 10;
  showPagination = false;
  tenantCompanyName: string = null;
  tenantCompanyAddress: string = null;
  multiSelecttenant: any = [];
  selectedTenantName: any;
  membersDeepCopy: any;
  orgTenant: any;

  constructor(private apiService: ApiService, private appStateSrv: AppStateProvider) { }

  ngOnInit(): void {

    this.getApiauthorizationToken();
    this.tenantCompanyName = localStorage.getItem(AppConstant.localStorage.creditCompanyName);
    this.tenantCompanyAddress = localStorage.getItem(AppConstant.localStorage.creditCompanyAddress);
    this.getTenantCredit();

    this.meetingNav = [
      {
        index: "6",
        name: "Credits",
        link: '/credits/credit-details'
      }
    ];

    const route = {
      index: "6",
      name: "Credits",
      link: '/credits/credit-details'
    };
    this.appStateSrv.setSideNavState(route);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  getApiauthorizationToken() {

    this.token = 'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
    if (this.token != null) {
      console.log('token verification');
      this.getTenantUser()
    }

  };

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();

    } else {
      popover.open();

    }
  }


  selectEmailid(item) {
    console.log(item, this.multiSelecttenant);
    if (item.userId !== null)
      this.searchTerm = '';
    this.selectedTenantName = item.userName;
    if (item.userId !== null)
      if (this.multiSelecttenant.includes(item.userId))
        this.multiSelecttenant.splice(
          this.multiSelecttenant.indexOf(item.userId),
          1
        );
      else this.multiSelecttenant.push(item.userId);
    else this.multiSelecttenant = [];

    console.log('multiSelecttenant', this.multiSelecttenant);
    console.log(this.membersDeepCopy);

    if (this.multiSelecttenant.length != 0) {
      if (this.multiSelecttenant.includes('All')) {
        this.tenantUser = this.membersDeepCopy;
      }
      this.tenantUser = this.membersDeepCopy.filter((data) => {

        if (this.multiSelecttenant.includes(data.userId))
          return data
      });
    } else {
      this.tenantUser = this.membersDeepCopy;
    }

    console.log('tenantDetail', this.tenantUser);

    if (this.multiSelecttenant.length >= 1)
      this.selectedTenantName = this.tenantUser.filter(company => company.userId === this.multiSelecttenant[0])[0].userName;
    else
      this.selectedTenantName = "All"

    this.handlePageChange(1)
  }

  startSearch() {
    this.selectEmailid({ userId: null, userName: 'All' })
  }

  handlePageChange(event) {
    this.page = event;
    this.tenant = this.tenantUser.slice(0, this.tenantUser.length < 10 ? this.tenantUser.length : (this.page - 1) * this.pageSize + this.pageSize);
  }

  getTenantUser() {
    this.tenant.Id = (localStorage.getItem(AppConstant.localStorage.creditId));
    this.url = APIs.getTenantUser;
    // if (this.tenant && Object.keys(this.tenant).length !== 0 && this.tenant.constructor === Object && this.tenant.id) {
    this.url = this.url + "?TenantId=" + this.tenant.Id
    // this.url = this.url + "?TenantId=10";

    console.log('id', this.tenant.id);
    const header = {
      Authorization: this.token
    }
    this.apiService.get(this.url, "", header).subscribe(response => {
      console.log('response', response);
      if (response && response.list.length > 0) {
        this.tenantUsers = response.list;
        this.selectedTenantName = 'All';
        this.membersDeepCopy = JSON.parse(JSON.stringify(this.tenantUsers));
        this.tenantUser = this.membersDeepCopy;
        if (this.tenantUsers) {
          this.handlePageChange(1)
          this.selectEmailid({ userId: null, userName: 'All' })
        }
        // this.refreshPagination();
      }
      else {
        //handle null values here
      }
    },
      error => {
        //handle errors here
      })
    // } else {
    //   //handle null values here
    // }
  }

  getTenantCredit() {
    this.tenant.Id = (localStorage.getItem(AppConstant.localStorage.creditId));
    this.url = APIs.getTenantCredit;
    this.url = this.url + "?TenantId=" + this.tenant.Id
    const header = {
      Authorization: this.token
    }
    this.apiService.get(this.url, "", header).subscribe(response => {
      if (response && response.list.length > 0) {
        this.orgTenant = response.list;
      }

    },
      error => {
        //handle errors here
      })

  }

  emitRefresh() {
    this.refreshCredit.emit(false);
  }

  getTotalCredit(creditArray: any) {
    let totalCredit = 0;
    if (creditArray !== undefined && creditArray.length > 0) {
      creditArray.forEach((creditResult: any) => {
        totalCredit = totalCredit + creditResult.totalCreditPoints
      });
      return totalCredit;
    }
  }

  // getTenantTotalCredit(pointArray: [], type: string, creditPointType: number) {
  //   let poolCreditPoints = 0;
  //   let reservedCreditPoints = 0;
  //   let totalCreditPoints = 0;
  //   if (pointArray !== undefined && pointArray.length > 0) {
  //     pointArray.find((findCredit: any) => {
  //       if (findCredit.creditPointTypeId === creditPointType) {
  //         poolCreditPoints = findCredit.poolCreditPoints;
  //         totalCreditPoints = findCredit.totalCreditPoints
  //         reservedCreditPoints = findCredit.reservedCreditPoints
  //       }
  //     });
  //   }
  //   if (type == 'spent') {
  //     return poolCreditPoints + reservedCreditPoints;
  //   }
  //   return totalCreditPoints;
  // }

  getTenantTotalCredit(pointArray: [], type: string, creditPointType: number) {
    let poolCreditPoints = 0;
    let reservedCreditPoints = 0;
    let totalCreditPoints = 0;
    let usedReservedCreditPoints = 0;
    let UsedPoolCreditPoints = 0;

    if (pointArray !== undefined && pointArray.length > 0) {
      pointArray.find((findCredit: any) => {
        if (findCredit.creditPointTypeId === creditPointType) {
          poolCreditPoints = findCredit.poolCreditPoints;
          totalCreditPoints = findCredit.totalCreditPoints;
          reservedCreditPoints = findCredit.reservedCreditPoints;
          usedReservedCreditPoints = findCredit.usedReservedCreditPoints;
          UsedPoolCreditPoints = findCredit.usedPoolCreditPoints;
        }
      });
    }
    if (type == 'total') return reservedCreditPoints + poolCreditPoints;

    return (reservedCreditPoints + poolCreditPoints) - (usedReservedCreditPoints + UsedPoolCreditPoints)

  }


  searchUser(value: string, type: string) {
    this.showPagination = false;
    if (value && type === 'select') {
      if (value == "All") {
        // this.refreshPagination();
        return this.tenantUser;
      }
      this.tenantUser = this.tenantUsers;
      this.tenantUser = this.tenantUser.filter((response: any) => {
        if (response.userId == value) {
          return this.tenantUser;
        }
      });
    } else {
      if (this.searchTerm.length == 0) {
        return this.refreshPagination();
      }
      this.tenantUser = this.tenantUsers;
      return this.tenantUser = this.tenantUser.filter(res => {
        return res.userName.toLowerCase().indexOf(this.searchTerm) > -1
      })
    }
  }

  refreshPagination() {
    if (this.tenantUsers && this.tenantUsers !== undefined && this.tenantUsers.length > 0) {
      this.showPagination = true;
      this.tenantUser = this.tenantUsers.map(
        (tenant: any, i: any) => ({ id: i + 1, ...tenant })).slice(
          (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }
  }

  generateInitials(fullName: string): string {
    if (fullName !== '' && fullName !== null && fullName !== undefined)
      return (
        fullName.split(' ')[0].charAt(0).toUpperCase() +
        '' +
        (fullName.split(' ')[1] === undefined || fullName.split(' ')[1] === null
          ? ''
          : fullName.split(' ')[1].charAt(0).toUpperCase())
      );
    else return '';
  }

  maskName(name: string): string {
    if (!name || !name.trim()) {
      return name;
    }

    return name
      .split(' ')
      .map(word =>
        word.length > 1
          ? word[0] + '*'.repeat(word.length - 1)
          : word
      )
      .join(' ');
  }

  maskPhone(phone: string): string {
    if (!phone) {
      return phone;
    }

    const digits = phone.replace(/\D/g, '');

    if (digits.length < 4) {
      return phone;
    }

    return (
      digits.substring(0, 2) +
      '*'.repeat(digits.length - 4) +
      digits.substring(digits.length - 2)
    );
  }

  maskEmail(email: string): string {
    if (!email) {
      return email;
    }

    const atIndex = email.indexOf('@');

    if (atIndex <= 2) {
      return '*'.repeat(atIndex) + email.substring(atIndex);
    }

    return (
      email.substring(0, 2) +
      '*'.repeat(atIndex - 2) +
      email.substring(atIndex)
    );
  }
}
